import { render, staticRenderFns } from "./SpotAlias.vue?vue&type=template&id=26a5de2e&"
import script from "./SpotAlias.vue?vue&type=script&lang=js&"
export * from "./SpotAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports